<div class="page-content container">
  <div class="page-header">
    <h1>
      {{ translationManager.getTranslation('Листа потенцијалних добављача') }}
    </h1>
  </div>
  <div class="page-data shadow-sm">
    <div class="page-part">
      <div class="alert alert-info">
        <span><i
            class="fa fa-info-circle"></i>{{ translationManager.getTranslation('Страница за приказ потенцијалних добављача') }}</span>
      </div>
    </div>
    <div class="page-part" *ngIf="auth.isAuthorized('492CBB82-9314-4EAD-BB14-669848ACB4B7') &&
    state === viewState.Edit &&
    (requestStatus == requestStatusUniqueIdentifier.inProgress || requestStatus == requestStatusUniqueIdentifier.changesBack)">
      <div class="page-actions">
        <button class="btn btn-success" (click)="selectSuppliers()"><i class="fa fa-plus mr-1"></i>
          {{ translationManager.getTranslation('Додати новог добављача') }}</button>
      </div>
    </div>

    <div class="app-table-panel" app-table>

      <!-- <div class="app-table-used-filters">
        <div class="app-table-used-filters-title">
          <span>{{ translationManager.getTranslation('Искоришћени филтери') }}</span>
        </div>
        <div class="app-table-used-filter-items" search-tags>
          <div class="app-table-used-filter-items-no-content" search-tag-no-content>
            <span>{{ translationManager.getTranslation('Без искоришћених филтера') }}</span>
          </div>
          <div class="app-table-used-filter-item" style="display: none" search-tag-prototype>
            <span><i search-tag-prototype-title></i><i class="app-table-used-filter-item-value"
                search-tag-prototype-value></i></span>
            <a href="javascript:;" [title]="translationManager.getTranslation('Обрисати филтер')"
              search-tag-prototype-close>
              <i class="fas fa-times"></i>
            </a>
          </div>
          <div class="app-table-used-filter-item app-table-used-filter-item-order" style="display: none"
            order-tag-prototype>
            <span><i order-tag-prototype-title></i><i class="app-table-used-filter-item-value"
                order-tag-prototype-value></i></span>
            <a href="javascript:;" [title]="translationManager.getTranslation('Обрисати филтер')"
              order-tag-prototype-close>
              <i class="fas fa-times"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="app-table-filter-panel" filter>
        <div class="app-table-filter-icon">
          <a href="javascript:;" [title]="translationManager.getTranslation('Филтрирај ентитете')" filter-open>
            <i class="fas fa-filter"></i>
          </a>
        </div>
        <div class="app-table-filter">
          <div class="app-table-filter-search">
            <div class="app-table-filter-title">
              <span>{{ translationManager.getTranslation('Филтери') }}</span>
              <a href="javascript:;" [title]="translationManager.getTranslation('Затвори филтер')" filter-close>
                <i class="fas fa-times"></i>
              </a>
            </div>
            <div class="page-part">
              <div class="alert alert-info">
                <span><i
                    class="fa fa-info-circle"></i>{{ translationManager.getTranslation('Доступни филтери за процес филтрирања података') }}</span>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{ translationManager.getTranslation('ПИБ') }}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="PibVatJmbg"
                    [search-title-new]="translationManager.getTranslation('ПИБ')"
                    search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{ translationManager.getTranslation('Назив добављача') }}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="Name"
                    [search-title-new]="translationManager.getTranslation('Назив добављача')" search-action="contains">
                </div>
              </div>
            </div>

            <div class="app-form-element-buttons">
              <button class="btn btn-success" do-search><i
                  class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Филтрирај') }}</button>
              <button class="btn btn-danger" reset-search><i
                  class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Поништи') }}</button>
            </div>

          </div>
        </div>
      </div> -->

      <div class="app-table">
        <table class="table table-striped text-dark-m1">
          <thead>
            <tr class="bgc-primary-tp2 text-white">
              <th>
                <!-- <a href="javascript:;"
                  [title]="translationManager.getTranslation('Сортирање по ПибВатЈмбг')" order
                  order-entity="PibVatJmbg">
                  {{ translationManager.getTranslation('ПибВатЈмбг') }}
                </a> -->
                {{ translationManager.getTranslation('ПибВатЈмбг') }}
              </th>
              <th>
                <!-- <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по називу добављача')" order
                  order-entity="Name">
                  {{ translationManager.getTranslation('Назив добављача') }}
                </a> -->
                {{ translationManager.getTranslation('Назив добављача') }}
              </th>
              <th style="width: 140px" class="right" *ngIf="state === viewState.Edit">
                {{ translationManager.getTranslation('Акције') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items">
              <td>{{item.pibVatJmbg}}</td>
              <td>{{item.name}}</td>
              <td class="right" *ngIf="state === viewState.Edit">
                <div class="table-actions">
                  <a *ngIf="auth.isAuthorized('F3886523-76D6-4FBE-B219-67E969BF91A8') && (requestStatus == requestStatusUniqueIdentifier.inProgress || requestStatus == requestStatusUniqueIdentifier.changesBack)"
                      href="javascript:;" (click)="showDeleteModalFor(item.id)" class="red" [title]="translationManager.getTranslation('Брисање')">
                      <i class="far fa-trash-alt"></i>
                 </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="no-content" *ngIf="!items || items.length == 0">
          <span>{{ translationManager.getTranslation('Без података') }}</span>
        </div>
      </div>
      <!-- <div class="app-table-pagination">
        <div>
          <div pagination>
            <span>{{ translationManager.getTranslation('Страна') }}</span>
            <select pagination-pages>
              <option>1</option>
            </select>
            <span>{{ translationManager.getTranslation('од') }}</span>
            <span pagination-pages-count>-</span>
            <span class="app-table-pagination-arrows">
              <a href="javascript:;" [title]="translationManager.getTranslation('Иди на почетак')"
                pagination-first-page>
                <i class="fas fa-angle-double-left"></i>
              </a>
              <a href="javascript:;" [title]="translationManager.getTranslation('Претходна')" pagination-previous-page>
                <i class="fas fa-angle-left"></i>
              </a>
            </span>
            <span class="app-table-pagination-arrows">
              <a href="javascript:;" [title]="translationManager.getTranslation('Следећа')" pagination-next-page>
                <i class="fas fa-angle-right"></i>
              </a>
              <a href="javascript:;" [title]="translationManager.getTranslation('Иди на крај')" pagination-last-page>
                <i class="fas fa-angle-double-right"></i>
              </a>
            </span>
            <span>{{ translationManager.getTranslation('Број редова за приказ') }}</span>
            <select pagination-sizes>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>
        <div class="app-table-pagination-sizes">
          <div>
            <span>{{ translationManager.getTranslation('Укупан број слогова') }}</span>
            <span pagination-total-count>-</span>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div>

<app-modal [show]="showDeleteModal" [title]="translationManager.getTranslation('Брисање потенцијалног добављача?')">
  <div class="app-modal-content">
    {{ translationManager.getTranslation('Да ли сте сигурни да желите да обришете потенцијалног добављача?') }}
  </div>
  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="delete()">
      <i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Да') }}</button>
    <button (click)="showDeleteModal = false" class="btn btn-warning">
      <i class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Не') }}</button>
  </div>
</app-modal>

<supplier-select #supplierSelect></supplier-select>

